import { memo, useMemo } from 'react'

import { StoreOfferProduct } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { useIsLoggedIn } from '@/features/common/useIsLoggedIn'
import { STORE_BG } from '@/features/storefronts/_storeBase/constants'
import { useGameSlug } from '@/features/storefronts/game-provider'
import { useBreakpoints } from '@/utils/useBreakpoints'

import { getShortSlugNotHD } from '../../../../fixtures/games'
import { LoginButton } from '../../../header/LoginButton'
import { CardBundle } from '../card/CardBundle'
import { StoreTypography } from '../typography/StoreTypography'

import storeStyles from '../storefronts.module.scss'
import styles from './bundles.module.scss'

export const Bundles = memo(({ bundles }: { bundles: StoreOfferProduct[] }) => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const from = useBreakpoints().from
  const isDesktop = from('tablet')
  const loggedIn = useIsLoggedIn()

  const shortSlug = getShortSlugNotHD(gameSlug)

  const useLoggedInText = useMemo(() => {
    return bundles.length === 0 ? t('specials_not_available') : t.rich(`${shortSlug}_specials_available`)
  }, [t, bundles.length, shortSlug])

  return (
    <div
      className={cx(
        styles.bundles,
        styles[gameSlug],
        storeStyles[gameSlug],
        storeStyles.topOverlap,
        storeStyles.bottomOverlap,
      )}
      style={{ backgroundImage: STORE_BG(gameSlug) }}
    >
      <div id="storespecials" className={styles.specialsHeading}>
        <div className={styles.title}>
          <StoreTypography className={styles.titleText} tag="h1" textSize={isDesktop ? 'xl' : 'lg'} style="outlined">
            {t('specials_title')}
          </StoreTypography>
        </div>
        <StoreTypography
          tag="p"
          style="plain"
          textSize={isDesktop ? 'md' : 'body'}
          overrideFont="supercellText"
          lineHeight="normal"
        >
          {loggedIn ? useLoggedInText : t('specials_login')}
        </StoreTypography>
        {!loggedIn ? <LoginButton /> : null}
      </div>
      <div className={styles.bundlesContainer}>
        {bundles.map((bundle, index) => (
          <CardBundle key={index} game={gameSlug} bundle={bundle} />
        ))}
      </div>
    </div>
  )
})

Bundles.displayName = 'Bundles'
